import { PoetryMetadata } from '@/api';
import { isEmpty } from '@/shared/util';

export const filterImagingServices = (poetryMetadata?: Partial<PoetryMetadata>): PoetryMetadata => {
  if (isEmpty(poetryMetadata) || isEmpty(poetryMetadata?.servicesInfo)) {
    return {} as PoetryMetadata;
  }

  return {
    servicesInfo: (poetryMetadata?.servicesInfo ?? []).filter((service) =>
      service.code.startsWith('IMAGING.BASE.'),
    ),
  };
};
